import React, { FunctionComponent, memo, useEffect } from 'react';
import { Box, Grid } from '@material-ui/core';
import IFeature from '../../../../../../model/IFeature';
import FeatureColor from '../FeatureColor';
import featureColorListStyles from './featureColorListStyles';
import ICategoryAttributes from '../../../../../../model/ICategoryAttributes';
import useDxpDataLayer from '../../../../../../../common/hooks/useDxpDataLayer';

export interface IFeaturesListProps {
  features: IFeature[];
  onClick: (id: string) => void;
  selectedCode: string;
  categoryAttributes?: ICategoryAttributes;
}

const FeatureColorList: FunctionComponent<IFeaturesListProps> = memo(
  ({ features, onClick, selectedCode, categoryAttributes }) => {
    const styles = featureColorListStyles();

    const { setInitialColors } = useDxpDataLayer();

    useEffect(() => {
      setInitialColors(features, categoryAttributes);
    }, []);

    return (
      <Grid container={true} direction={'row'} className={styles.container}>
        <Grid container={true} data-test="options:container">
          {features?.map((feature: IFeature, index: number) => {
            return (
              <Box mx={1} mb={1} key={index} data-test={`option:${feature.code}`}>
                <FeatureColor
                  key={index}
                  id={feature.code}
                  feature={feature}
                  onClick={onClick}
                  selectedCode={selectedCode}
                  isDisabled={false}
                  categoryAttributes={categoryAttributes}
                />
              </Box>
            );
          })}
        </Grid>
      </Grid>
    );
  },
);

export default FeatureColorList;
